import React from 'react';
import { Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import SubNavigation from '../../sub-navigation';
import { TabItem } from '../../sub-navigation/types';

const TR_TABS: TabItem[] = [
  {
    label: 'Incoming',
    to: 'incoming',
  },
  {
    label: 'In Progress',
    to: 'in-progress',
  },
  {
    label: 'My Queue',
    to: 'my-queue',
  },
  {
    label: 'Reminders',
    to: 'reminders',
  },
  {
    label: 'All Requests',
    to: 'all',
  },
  {
    label: 'New Request',
    to: 'create',
    sx: {
      display: { mobile: 'none', desktop: 'block' },
      borderRadius: '0.5rem',
      border: '1px solid',
      borderColor: 'divider',
      padding: '0.5rem 0.5rem',
      minHeight: '0',
      maxHeight: '2.5rem',
      alignSelf: 'center',
      fontWeight: 'bold',
      '&:hover': {
        color: 'initial',
        backgroundColor: '#F9F9FB',
      },
    },
  },
];

const TripRequestsSubNavigation = () => (
  <SubNavigation
    endAdornment={(
      <Button
        component={Link}
        to="create"
        sx={{
          display: { desktop: 'none' },
          textDecoration: 'none',
          borderColor: 'divider',
          whiteSpace: 'nowrap',
        }}
        size="small"
        variant="outlined"
      >
        New Request
      </Button>
    )}
    profile={{
      primary: (
        <Typography
          component="span"
          variant="h3"
        >
          Trip Requests
        </Typography>),
    }}
    tabs={TR_TABS}
  />
);

export default TripRequestsSubNavigation;
